<template>
  <v-data-table
    density="compact"
    hide-default-footer
    :headers="getHeader()"
    :items="claims"
    :items-per-page="-1"
    :mobile-breakpoint="960"
  >
    <template #item.date="{item}">
      {{ (item.date, $t('commonStrings.dateDisplayFormat')) }}
    </template>
    <template #item.claimTypeId="{item}">
      {{ $t(`enums.receiptTypes.${item.claimTypeId}`) }}
    </template>
    <template #item.usesSalaryFraction="{item}">
      <v-checkbox
        v-model="item.usesSalaryFraction"
        color="primary"
        :label="$t('commonStrings.salaryFractionLabel')"
        disabled
      />
    </template>
    <template #item.payingOrgs="{item}">
      <paying-orgs-label :paying-orgs="item.payingOrgs" />
    </template>
    <template #item.attachments="{item}">
      {{ $t('receiptsPanelStrings.labels.attachmentCount', [item.attachments.length]) }}
    </template>
    <template #item.amount="{item}">
      <amount-label :value="item.amount" />
    </template>
    <template #item.editAction="{ item }">
      <v-btn
        rounded
        size="small"
        class="primary-inverted-button my-2"
        @click="onEdit(item)"
      >
        {{ $t("receiptsPanelStrings.labels.editButton") }}
      </v-btn>
    </template>
    <template #item.removeAction="{ item }">
      <v-btn
        rounded
        size="small"
        class="accent-inverted-button my-2"
        @click="onRemove(item)"
      >
        {{ $t("receiptsPanelStrings.labels.removeButton") }}
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import AmountLabel from "@/views/common/components/AmountLabel";
import PayingOrgsLabel from "@/views/applications/components/PayingOrgsLabel";
import { m } from '@/plugins/moment';

export default {
  name: "ReceiptsTable",
  components: {
    AmountLabel,
    PayingOrgsLabel
  },
  props: {
    claims: {
      default: () => [],
      type: Array
    },
    remove: Function,
    canUseSalaryFraction: {
      required: true
    }
  },
  setup() {
    return { m };
  },
  methods: {
    getHeader() {
      const headers = [
        {
          text: this.$t("receiptsPanelStrings.tableHeaders.date"),
          value: "date",
          sortable: false,
          filterable: false
        },
        {
          text: this.$t("receiptsPanelStrings.tableHeaders.expenseType"),
          value: "claimTypeId",
          sortable: false,
          filterable: false
        },
        {
          text: this.$t("receiptsPanelStrings.tableHeaders.payingOrgs"),
          value: "payingOrgs",
          sortable: false,
          filterable: false
        },
        {
          text: this.$t("receiptsPanelStrings.tableHeaders.attachment"),
          value: "attachments",
          sortable: false,
          filterable: false
        },
        {
          text: this.$t("receiptsPanelStrings.tableHeaders.amount"),
          value: "amount",
          sortable: false,
          filterable: false
        },
        {
          text: this.$t("receiptsPanelStrings.tableHeaders.comment"),
          value: "comment",
          sortable: false,
          filterable: false
        },
        {
          value: "editAction",
          sortable: false,
          filterable: false
        },
        {
          value: "removeAction",
          sortable: false,
          filterable: false
        }
      ];
      if (this.canUseSalaryFraction) {
        headers.splice(2, 0, {
          text: this.$t("commonStrings.salaryFraction"),
          value: "usesSalaryFraction",
          sortable: false,
          filterable: false
        });
      }

      return headers;
    },
    onEdit(claim) {
      const index = this.claims.indexOf(claim);
      this.$emit('edit-clicked', {claim, index} );
    },
    onRemove(claim) {
      const index = this.claims.indexOf(claim);
      this.$emit('remove-clicked', {claim, index} );
    }
  }
};
</script>